import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RequirementActionResponse, RequirementApiResponse } from "../model/requirement.model";
import { RequirementAttachmentListRequest, RequirementAttachmentRequest, RequirementAttachmentResponse } from "../model/requirement-attachment.model";
import { BASE_PATH } from "../variables";

@Injectable({ providedIn: "root" })
export class StaffRequirementAttachmentsService {
  private readonly requirementsUrl: string;

  constructor(private readonly http: HttpClient, @Inject(BASE_PATH) basePath: string) {
    this.requirementsUrl = `${basePath.replace(/\/$/, "")}/api/v1/requirements`;
  }

  list(id: number, request: RequirementAttachmentListRequest = {}): Observable<RequirementApiResponse<readonly RequirementAttachmentResponse[]>> {
    let params = new HttpParams();
    if (request.attachmentType) params = params.set("attachmentType", request.attachmentType);
    if (request.includeDeleted !== undefined) params = params.set("includeDeleted", request.includeDeleted);
    return this.http.get<RequirementApiResponse<readonly RequirementAttachmentResponse[]>>(`${this.requirementsUrl}/${id}/attachments`, { params });
  }

  create(id: number, request: RequirementAttachmentRequest): Observable<RequirementApiResponse<RequirementAttachmentResponse>> {
    return this.http.post<RequirementApiResponse<RequirementAttachmentResponse>>(`${this.requirementsUrl}/${id}/attachments`, request);
  }

  delete(id: number, attachmentId: number): Observable<RequirementActionResponse> {
    return this.http.delete<RequirementActionResponse>(`${this.requirementsUrl}/${id}/attachments/${attachmentId}`);
  }
}
